module.exports = __webpack_public_path__ + "img/LOLY.03cf3388.png";